import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigation } from 'swiper';
/* eslint-disable import/no-unresolved */
import { Swiper, SwiperSlide } from 'swiper/react';
import CategoryCard from 'sealink/react-components/category-card';

/* eslint-enable import/no-unresolved */

const CategoryCardsCarousel = ({ categories }) => {
  const swiperRef = useRef(null);
  const [mostLeft, setMostLeft] = useState(true);
  const [mostRight, setMostRight] = useState(false);

  const setCarouselPosition = () => {
    setMostLeft(swiperRef.current.swiper.isBeginning);
    setMostRight(swiperRef.current.swiper.isEnd);
  };

  return (
    <div className="category-cards-carousel">
      <div
        className={`d-none d-xxl-block category-cards-carousel__previous-button ${
          mostLeft && 'opacity-25'
        }`}
        onClick={() => swiperRef.current.swiper.slidePrev()}
      >
        <i className="far fa-angle-left" />
      </div>
      <div
        className={`d-none d-xxl-block category-cards-carousel__next-button ${
          mostRight && 'opacity-25'
        }`}
        onClick={() => swiperRef.current.swiper.slideNext()}
      >
        <i className="far fa-angle-right" />
      </div>
      <Swiper
        simulateTouch
        slidesOffsetBefore={16}
        slidesOffsetAfter={16}
        slidesPerView={1.3}
        spaceBetween={24}
        modules={[Navigation]}
        ref={swiperRef}
        breakpoints={{
          576: {
            slidesPerView: 2.5,
          },
          992: {
            slidesPerView: 4.5,
          },
        }}
        onSlideChange={() => setCarouselPosition()}
      >
        {categories.map((category, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SwiperSlide key={index}>{CategoryCard(category)}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CategoryCardsCarousel;

CategoryCardsCarousel.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      previewImage: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string,
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
      }),
      url: PropTypes.string.isRequired,
    })
  ),
};
